import React, { useState, useRef } from 'react';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ReactComponent as Edit } from 'assets/icons/edit-icon.svg';
import { TextField, Popper, SvgIcon } from '@mui/material';
import * as S from './DateFilterTotal.styled';

type DateFilterTotalProps = {
    fromDate: string;
    toDate: string;
    totalAmount: number;
    onEdit: (from: Date, to: Date) => void;
};

export default function DateFilterTotal({
    fromDate,
    toDate,
    totalAmount,
    onEdit,
}: DateFilterTotalProps) {
    const [from, setFrom] = useState<Date | null>(new Date(fromDate));
    const [to, setTo] = useState<Date | null>(new Date(toDate));
    const [open, setOpen] = useState(false);
    const anchorRef = useRef<HTMLButtonElement>(null);

    return (
        <S.Container>
            <S.DateInfo>
                <span className="text-sm text-gray-500">
                    {from?.toLocaleDateString()} - {to?.toLocaleDateString()}
                </span>
                <S.Amount>
                    <span style={{ color: '#565E6C' }}>Total Amount Collected:</span>
                    <span style={{ color: '#6025D8', fontWeight: '600' }}>
                        ${totalAmount.toLocaleString()}
                    </span>
                </S.Amount>
            </S.DateInfo>

            <S.EditButton onClick={() => setOpen(!open)} ref={anchorRef}>
                <SvgIcon
                    style={{ width: 24, height: 48 }}
                    viewBox="0 0 21 30"
                    htmlColor="black"
                    onClick={() => console.log('sfsaf')}
                    component={Edit}
                />
            </S.EditButton>

            {open && (
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Popper
                        open={open}
                        anchorEl={anchorRef.current}
                        placement="bottom-end"
                        style={{ zIndex: 1300 }}
                    >
                        <div
                            style={{
                                background: 'white',
                                padding: '1rem',
                                borderRadius: '8px',
                                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <DesktopDatePicker
                                label="From"
                                inputFormat="MM/dd/yyyy"
                                value={from}
                                onChange={(newDate) => setFrom(newDate)}
                                renderInput={(params) => <TextField {...params} size="small" />}
                            />
                            <DesktopDatePicker
                                label="To"
                                inputFormat="MM/dd/yyyy"
                                value={to}
                                onChange={(newDate) => setTo(newDate)}
                                renderInput={(params) => (
                                    <TextField {...params} size="small" sx={{ mt: 2 }} />
                                )}
                            />
                            <button
                                onClick={() => {
                                    setOpen(false);
                                    if (from && to) onEdit(from, to);
                                }}
                                style={{
                                    marginTop: '0.75rem',
                                    backgroundColor: '#6366f1',
                                    color: 'white',
                                    border: 'none',
                                    padding: '0.5rem 1rem',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                }}
                            >
                                Apply
                            </button>
                        </div>
                    </Popper>
                </LocalizationProvider>
            )}
        </S.Container>
    );
}
